import { Container } from "./styles";
import { FiSettings } from "react-icons/fi";

interface GearButtonProps {
  showModal: () => void;
}

export const GearButton = ({ showModal }: GearButtonProps) => {
  return (
    <Container type="button" onClick={showModal}>
      <FiSettings />
    </Container>
  );
};
